export const PNGENERICFORM_LOAD = 'PNGENERICFORM_LOAD';
export const PNGENERICFORM_RECEIVE = 'PNGENERICFORM_RECEIVE';
export const PNGENERICFORM_DISPLAY_STATE = 'PNGENERICFORM_DISPLAY_STATE';
export const PNGENERICFORM_INFORMATION_SENT = 'PNGENERICFORM_INFORMATION_SENT';
export const PNGENERICFORM_ERROR = 'PNGENERICFORM_ERROR';